import { ArrowDown, Users, Bike, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../../lib/i18nRouting";
import { HERO_IMAGE } from "../../data/experiences";

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden bg-forest-deep" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt={t("meta.site.tagline")} fetchPriority="high" decoding="async" width="1600" height="739" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-forest-deep/60 via-forest-deep/30 to-forest-deep/85" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative z-10 flex flex-col min-h-[100svh] max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-16">
        <div className="flex-1 flex flex-col justify-center">
          <div className="text-xs uppercase tracking-wider-3 text-bone/80 mb-8 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-bone/60" />
            {t("hero.eyebrow")}
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl text-bone leading-[1.02] tracking-tight max-w-5xl">
            {t("hero.title_a")} <span className="italic font-light">{t("hero.title_b")}</span><br />
            {t("hero.title_c")} <span className="italic font-light">{t("hero.title_d")}</span>.
          </h1>

          <p className="mt-8 text-bone/85 text-base sm:text-lg max-w-xl leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <LocalizedLink
              to="/experiente"
              data-testid="hero-cta-explore"
              className="btn-lift inline-flex items-center justify-center px-8 py-4 bg-bone text-forest text-xs uppercase tracking-wider-3 hover:bg-bone-deep"
            >
              {t("hero.cta_explore")}
            </LocalizedLink>
            <LocalizedLink
              to="/rezervare"
              data-testid="hero-cta-availability"
              className="btn-lift inline-flex items-center justify-center px-8 py-4 border border-bone/60 text-bone text-xs uppercase tracking-wider-3 hover:bg-bone hover:text-forest"
            >
              {t("hero.cta_book")}
            </LocalizedLink>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-12 gap-y-6 pt-12 border-t border-bone/15">
          <Badge icon={<Users className="w-4 h-4" />} label={t("hero.badges.small_groups")} sub={t("hero.badges.small_groups_sub")} />
          <Badge icon={<Bike className="w-4 h-4" />} label={t("hero.badges.ebikes")} sub={t("hero.badges.ebikes_sub")} />
          <Badge icon={<MapPin className="w-4 h-4" />} label={t("hero.badges.pickup")} sub={t("hero.badges.pickup_sub")} />
        </div>

        <div className="hidden md:flex absolute bottom-8 right-6 lg:right-12 items-center gap-2 text-bone/70 text-xs uppercase tracking-wider-2">
          <ArrowDown className="w-4 h-4 animate-bounce" />
          {t("hero.scroll")}
        </div>
      </div>
    </section>
  );
}

function Badge({ icon, label, sub }) {
  return (
    <div className="flex items-start gap-3 text-bone/90">
      <div className="mt-1 opacity-80">{icon}</div>
      <div>
        <div className="text-xs uppercase tracking-wider-2">{label}</div>
        <div className="text-xs text-bone/60 mt-1">{sub}</div>
      </div>
    </div>
  );
}
